import { Outlet } from 'react-router-dom';

export const UserLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
